<template>
    <div id="myTabContent" class="tab-content">
        <div id="pend_content">
            <faq-item v-for="(item, i) in faqs" :key="(item.id+'_'+i)"
            :item="item"
            :isTarget="targetFaqId==item.id"
            :shipCategory="shipCategory"
            :onFaqFeedbackSuccess="onFaqFeedbackSuccess"
            v-on:faqClicked="changeTargetFaq"
            />
            
        </div>
        <div class="faq-pagination">
            <Pagination 
                :size="paginationConfig.pageSize"
                :current="paginationConfig.pageNo"
                :total="paginationConfig.total"
                :pageGroup="7"
                placement="right"
                @on-change="onPaginationChange"
            />
        </div>
    </div>
</template>

<script>
const FaqItem = () => import('@/components/Faq/FaqItem')
const Pagination = () => import('@/components/Review/Pagination')
import _ from 'lodash'
export default {
    name: "FaqList",
    components: {
        FaqItem,
        Pagination,
    },
    props: {
        faqItems: {
            type: Array,
            default () {
                return []
            }
        },
        shipCategory: {
            type: Object,
            default () {
                return {}
            }
        },
        faqCategory: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    data () {
        return {
            offset: 0,
            limit: 10,
            targetFaqId: 0
        }
    },
    methods: {
        changeTargetFaq (item) {
            this.targetFaqId = item.id
        },
        onFaqFeedbackSuccess (faqId, type) {
            this.$store.commit('SET_FAQ_SUGGESTION', {
                faqId,
                type
            })
        },
        onPaginationChange(page) {
            const offset = (page - 1) * this.limit
            if (offset != this.offset) {
                this.offset = offset
            }
        },
    },
    computed: {
        faqs () {
            return _.slice(this.faqItems, this.offset, this.limit + this.offset)
        },
        paginationConfig () {
            const currentPage = parseInt((this.offset) / this.limit) + 1;
            const allPage = parseInt((this.faqItems.length - 1) / this.limit) + 1;
            return {
                pageSize: this.limit,     //一页的数据条数
                pageNo: currentPage,        //当前页的索引
                total: this.faqItems.length,         //总的数据条数
                pageTotal: allPage      //总的页数
          }
        }
    },
    watch: {
        faqItems () {
            this.offset = 0
        }
    }

}
</script>

<style lang="less" scoped>
#myTabContent{
  display: inline-block;
  vertical-align: top;
  width: 76%;
}



.faq-pagination {
    margin-top: 40px;
}

</style>
